module.exports = __webpack_public_path__ + "img/Caminos desactivado.e259e103.svg";